// Maps a kid's card-collection state to one of the 16 hand-drawn
// Alien pet body images. Filenames are taken verbatim from
// /public/img/Alien/<N Cards>/<name>.png — folder names include
// spaces ("0 Cards", "1 Card", etc.) which is fine in URLs because
// the browser percent-encodes them.
//
// State key shape: { has_boost, has_spark, has_build, has_super }
// Bool order in the key string: boost | spark | build | super
// (matches the migration columns and the parent panel order).

const PATHS = {
  // 0 cards — neutral state. We treat decay_paused/sleepy as a
  // separate ambient signal; the default sprite is the unfed
  // baseline.
  "0000": "/img/Alien/0%20Cards/default.png",

  // 1 card
  "1000": "/img/Alien/1%20Card/boost_state.png",   // boost
  "0100": "/img/Alien/1%20Card/spark_state.png",   // spark
  "0010": "/img/Alien/1%20Card/build_state.png",   // build
  "0001": "/img/Alien/1%20Card/supers_state.png",  // super

  // 2 cards
  "1100": "/img/Alien/2%20Cards/boost+spark.png",
  "1010": "/img/Alien/2%20Cards/boost+build.png",
  "1001": "/img/Alien/2%20Cards/boost+supers.png",
  "0110": "/img/Alien/2%20Cards/build+spark.png",
  "0101": "/img/Alien/2%20Cards/sparks+supers.png",
  "0011": "/img/Alien/2%20Cards/build+supers.png",

  // 3 cards
  "1110": "/img/Alien/3%20Cards/build+boost+spark.png",         // missing super
  "1101": "/img/Alien/3%20Cards/boost+supers+sparks.png",       // missing build
  "1011": "/img/Alien/3%20Cards/build+supers+boost.png",        // missing spark
  "0111": "/img/Alien/3%20Cards/build+spark+supers.png",        // missing boost

  // 4 cards — fully fed
  "1111": "/img/Alien/4%20Cards/build+supers+boost+spark.png",
};

export function alienImageFor({ has_boost, has_spark, has_build, has_super }) {
  const key = `${has_boost ? 1 : 0}${has_spark ? 1 : 0}${has_build ? 1 : 0}${has_super ? 1 : 0}`;
  return PATHS[key] || PATHS["0000"];
}

export const ALIEN_SLUG = "alien";
